import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";

export default function LoadingSpinner({ label = "Loading…" }) {
  return (
    <div
      className="d-flex align-items-center justify-content-center py-5 my-auto"
      style={{ minHeight: "50vh" }}
    >
      <div className="text-center">
        <div
          className="spinner-border"
          style={{ color: colors.violate }}
          role="status"
        />
        <p className="mt-3 mb-0" style={{ color: colors.textColor }}>
          {label}
        </p>
      </div>
    </div>
  );
}
